import { render, staticRenderFns } from "./ProductProperties.vue?vue&type=template&id=50f84d64"
import script from "./ProductProperties.vue?vue&type=script&lang=js"
export * from "./ProductProperties.vue?vue&type=script&lang=js"
import style0 from "./ProductProperties.vue?vue&type=style&index=0&id=50f84d64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports